/**
 * Requests and initiates the download of the sample order.
 */

const handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

function downloadSample(product) {

    const filename = 'sample';

    const link = document.createElement('a');
    link.href = process.env.REACT_APP_FIND_API+'/order/getsample?product='+product;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

}
    
export default downloadSample;